export const getSelectOptions = (arr = []) => arr.map((i) => ({ value: i }));
